// extracted by mini-css-extract-plugin
module.exports = {"UserInfo":"UserInfo_UserInfo__3KkEx","time-asked":"UserInfo_time-asked__2vvIr","identity":"UserInfo_identity__3x75J","transparent":"UserInfo_transparent__1XEZY"};